import React, { FC, useState, useEffect, useCallback } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import cookie from 'react-cookies'

import 'react-responsive-modal/styles.css'
import * as EmailValidator from 'email-validator'
import { notify } from 'react-notify-toast'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import GenericMainCart from '../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericBackButton from '../../GenericComponents/GenericBackButton'
import Loader from '../Loader/Loader'

import LoginCardDefaultMode from './views/LoginCardDefaultMode.jsx'
import LoginCardLoginEmailMode from './views/LoginCardLoginEmailMode.jsx'
import LoginCardRemindPasswordMode from './views/LoginCardRemindPasswordMode.jsx'
import LoginCardRegisterMode from './views/LoginCardRegisterMode.jsx'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'

import {
  getUserLoggedInWithSocial,
  registerUser,
  LoginUser,
  remindUserPassword,
} from '../../Api/backendApi'

import history from '../../history'

import {
  LoginScreenBox,
  LoginWomanImage,
  LoginLogo,
  GoToCHallengeButton,
} from './style/LoginScreenStyle'
import Cookies from 'universal-cookie'
import { Button } from '@material-ui/core'

interface LoginScreenProps {
  storeUserEmail: Function
}

interface userRegisterDataInterface {
  email: string
  password: string
  rePassword: string
}

interface userLoginDataInterface {
  email: string
  password: string
}

const LoginScreen: FC<LoginScreenProps> = () => {
  const { promiseInProgress } = usePromiseTracker()
  const [open, setOpen] = useState(false)
  const [isUserRegisterModeOn, setUserRegisterModeOn] = useState(false)
  const [isUserLoginModeOn, setUserLoginModeOn] = useState(false)
  const [isUserRemindPasswordModeOn, setUserRemindPasswordMode] =
    useState(false)
  const [isUserDefaultMode, setUserDefaultMode] = useState(true)

  const [userAcceptedPolicies, setUserAcceptedPolicies] = useState(false)
  const [userAcceptedNewsletter, setUserAcceptedNewsletter] = useState(false)
  const [userRegisterData, setUserRegisterData] =
    useState<userRegisterDataInterface>({
      email: '',
      password: '',
      rePassword: '',
    })
  const [userLoginData, setUserLoginData] = useState<userLoginDataInterface>({
    email: '',
    password: '',
  })
  const [userRemindPasswordData, setUserRemindPasswordData] =
    useState<string>('')

  const onKeyUp = (event: any) => {
    if (event.key == 'Enter') {
      handleLoginUser()
    }
  }

  const handleChangeToEmailLoginMode = () => {
    setUserDefaultMode(false)
    setUserRegisterModeOn(false)
    setUserLoginModeOn(true)
    setUserRemindPasswordMode(false)
  }

  const handleChangeToRegisterMode = () => {
    setUserDefaultMode(false)
    setUserRegisterModeOn(true)
    setUserLoginModeOn(false)
    setUserRemindPasswordMode(false)
  }

  const handleChangeToDefaultMode = () => {
    setUserDefaultMode(true)
    setUserRegisterModeOn(false)
    setUserLoginModeOn(false)
    setUserRemindPasswordMode(false)
  }

  const handleChangeToRemindPasswordMode = () => {
    setUserDefaultMode(false)
    setUserRegisterModeOn(false)
    setUserLoginModeOn(false)
    setUserRemindPasswordMode(true)
  }

  const handleAcceptRegisterPolicies = () => {
    setUserAcceptedPolicies(!userAcceptedPolicies)
  }

  const handleAcceptNewsletter = () => {
    setUserAcceptedNewsletter(!userAcceptedNewsletter)
  }

  const handleGatherLoginInputData = (value: string, type: string) => {
    switch (type) {
      case 'email':
        setUserLoginData({ ...userLoginData, email: value })
        break
      case 'password':
        setUserLoginData({ ...userLoginData, password: value })
        break
      default:
        break
    }
  }

  const handleGatherRegisterInputData = (value: string, type: string) => {
    switch (type) {
      case 'password':
        setUserRegisterData({ ...userRegisterData, password: value })
        break
      case 'rePassword':
        setUserRegisterData({ ...userRegisterData, rePassword: value })
        break
      case 'email':
        setUserRegisterData({ ...userRegisterData, email: value })
        break
      default:
        break
    }
  }

  const responseFacebook = (response: any) => {
    getUserLoggedInWithSocial(
      response.email,
      response.id,
      response.accessToken,
      'facebok'
    )

    setTimeout(() => {
      if (response) {
        history.push('/redirect')
      }
    }, 1000)
  }

  const responseGoogle = async (response: any) => {
    const resp = await getUserLoggedInWithSocial(
      response.profileObj.email,
      response.profileObj.googleId,
      response.tokenObj.id_token,
      'google'
    )

    setTimeout(() => {
      if (resp) {
        history.push('/redirect')
      }
    }, 500)
  }

  const handleValidateRegisterData = () => {
    let validationPassed: boolean = false

    if (!EmailValidator.validate(userRegisterData.email)) {
      notify.show('Proszę wpisać prawidłowy email', 'warning', 5000)
      return
    }

    if (userRegisterData.password.length < 8) {
      notify.show('Hasło musi zawierać przynajmniej 8 znaków', 'warning', 5000)
      return
    }

    if (userRegisterData.password !== userRegisterData.rePassword) {
      notify.show('Hasła muszą się zgadzać', 'warning', 5000)
      return
    }

    if (!userAcceptedPolicies) {
      notify.show(
        'Musisz zaakceptować regulamin oraz politykę prywatności',
        'warning',
        5000
      )
      return
    } else {
      validationPassed = true
    }

    return validationPassed
  }

  const handleRegisterUser = async () => {
    let registerResponse: any

    if (handleValidateRegisterData()) {
      registerResponse = await trackPromise(
        registerUser(
          userRegisterData.email,
          userRegisterData.password,
          userAcceptedNewsletter
        )
      )

      if (registerResponse) {
        handleChangeToDefaultMode()
      }
    }
  }

  const handleLoginUser = async () => {
    if (
      userLoginData.email.length === 0 ||
      !EmailValidator.validate(userLoginData.email)
    ) {
      notify.show('Proszę wpisać email', 'warning', 5000)
      return
    }

    if (userLoginData.password.length == 0) {
      notify.show('Proszę wpisać hasło', 'warning', 5000)
      return
    }

    const isLoginSuccess = await LoginUser(
      userLoginData.email,
      userLoginData.password
    )

    if (isLoginSuccess) {
      history.push('/redirect')
    }
  }

  const handleRemindPassword = async () => {
    if (
      userRemindPasswordData.length === 0 ||
      !EmailValidator.validate(userRemindPasswordData)
    ) {
      notify.show('Proszę wpisać email', 'warning', 5000)
      return
    }

    await remindUserPassword(userRemindPasswordData)
    await handleChangeToDefaultMode()
  }

  const handleGatherRemindPasswordInputValue = (value: string) => {
    setUserRemindPasswordData(value)
  }

  return (
    <GenericBackgroundLayer className="standard login-mode">
      <LoginWomanImage
        className={`login-woman-image ${isTablet && 'tablet-view'}`}
      />
      {!isUserDefaultMode && (
        <GenericBackButton
          style={{ position: 'absolute', left: '20vw', top: '5vh' }}
          handleClick={handleChangeToDefaultMode}
        />
      )}
      <LoginScreenBox>
        <LoginLogo className="login-logo" />
        {isMobile && (
          <GenericTextSpan
            className="login-screen"
            fSize="1.3rem"
            margin={'0 0 20% 0'}
          >
            Cześć, super ze jesteś!
          </GenericTextSpan>
        )}
        <GenericMainCart
          className="standard login-mode login-mode-card"
          flexDir={'column'}
          position={isMobile ? 'relative' : 'absolute'}
          top={isMobile ? 'unset' : '22vh'}
          width={isMobile ? '90%' : '25vw'}
          // height={'63vh'}
          right={isMobile ? 'unset' : '19.5vw'}
          bottom={isMobile ? '15%' : 'unset'}
        >
          {!isMobile && (
            <GenericTextSpan
              className="login-screen"
              fSize="1.7rem"
              margin={'0 0 10% 0'}
            >
              {isUserLoginModeOn
                ? 'Logowanie'
                : isUserDefaultMode
                ? 'Cześć, super ze jesteś!'
                : isUserRemindPasswordModeOn
                ? 'Resetowanie hasła'
                : 'Rejestracja'}
            </GenericTextSpan>
          )}

          {isUserDefaultMode && (
            <LoginCardDefaultMode
              setUserLoginModeOn={handleChangeToEmailLoginMode}
              setUserRegisterModeOn={handleChangeToRegisterMode}
              responseFacebook={responseFacebook}
              responseGoogle={responseGoogle}
              handleChangeToRemindPasswordMode={
                handleChangeToRemindPasswordMode
              }
            />
          )}
          {isUserLoginModeOn && (
            <LoginCardLoginEmailMode
              setUserRegisterModeOn={handleChangeToRegisterMode}
              responseFacebook={responseFacebook}
              responseGoogle={responseGoogle}
              isUserLoginModeOn={isUserLoginModeOn}
              handleChangeToRemindPasswordMode={
                handleChangeToRemindPasswordMode
              }
              handleGatherLoginInputData={handleGatherLoginInputData}
              handleLoginUser={handleLoginUser}
              onKeyUp={onKeyUp}
            />
          )}

          {isUserRemindPasswordModeOn && (
            <LoginCardRemindPasswordMode
              handleGatherRemindPasswordInputValue={
                handleGatherRemindPasswordInputValue
              }
              handleRemindPassword={handleRemindPassword}
            />
          )}
          {isUserRegisterModeOn && (
            <LoginCardRegisterMode
              userAcceptedPolicies={userAcceptedPolicies}
              handleAcceptRegisterPolicies={handleAcceptRegisterPolicies}
              handleAcceptNewsletter={handleAcceptNewsletter}
              userAcceptedNewsletter={userAcceptedNewsletter}
              handleGatherRegisterInputData={handleGatherRegisterInputData}
              handleRegisterUser={handleRegisterUser}
            />
          )}
        </GenericMainCart>
      </LoginScreenBox>
      {promiseInProgress && <Loader />}
    </GenericBackgroundLayer>
  )
}

export default LoginScreen
